module.exports = __webpack_public_path__ + "static/img/yantai1.6678a447.jpg";